/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Err_Pick_ProductInputs */

const vi_form_err_pick_product = /** @type {(inputs: Form_Err_Pick_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn sản phẩm`)
};

/**

* @param {Form_Err_Pick_ProductInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const form_err_pick_product = /** @type {((inputs?: Form_Err_Pick_ProductInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Err_Pick_ProductInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_form_err_pick_product(inputs)
});